import * as THREE from "three";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
import { OutlinePass } from "three/examples/jsm/postprocessing/OutlinePass";
import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass";
import { GammaCorrectionShader } from "three/examples/jsm/shaders/GammaCorrectionShader";
import { FXAAShader } from "three/examples/jsm/shaders/FXAAShader";

import { switchMap } from "rxjs/operators";
import { of, zip } from "rxjs";

export const PostProcessingSystem = (world, props) => {
  const outlinedObject3Ds = [];

  const renderPass = new RenderPass(world.scene, world.camera);
  const fxaaPass = new ShaderPass(FXAAShader);

  world.composer.addPass(renderPass);
  world.composer.addPass(fxaaPass);
  
  const outlinePass = new OutlinePass(
    new THREE.Vector2(800, 600),
    world.scene,
    world.camera,
    outlinedObject3Ds
  );
  world.composer.addPass(outlinePass);  

  const gammaCorrectionPass = new ShaderPass(GammaCorrectionShader);
  world.composer.addPass(gammaCorrectionPass);

  // Outline stream

  const outline$ = world.data.hovers$.pipe(
    switchMap((items) =>
      items.length
        ? zip(
            ...items.map((hover) => world.object3DManager.getObject3D$(hover))
          )
        : of(items)
    )
  );

  outline$.subscribe((object3Ds) => {
    // clear array
    outlinedObject3Ds.length = 0;

    // add new items
    outlinedObject3Ds.push(...object3Ds.filter((object3D) => object3D));
    world.change$.next();
  });

  // update FXAA uniforms
  world.size$.subscribe((size) => {
    if (size) {
      const { width = 800, height = 600 } = size;
      const pixelRatio = world.renderer.getPixelRatio();
      fxaaPass.material.uniforms[ 'resolution' ].value.x = 1 / ( width * pixelRatio );
      fxaaPass.material.uniforms[ 'resolution' ].value.y = 1 / ( height * pixelRatio );
    }
  });
};

export default PostProcessingSystem;
